import { httpV1 as http } from '../api';

export async function saveVehicle(params) {
  return http
    .post('/clients/vehicle/admin', params)
    .then(({ data }) => data);
}

export async function getVehicle(account_id, vehicle_id) {
  return http
    .get(`/clients/${account_id}/vehicle/${vehicle_id}`)
    .then(({ data }) => data);
}

export async function updateVehicle(account_id, vehicle_id, params) {
  return http
    .put(`/clients/${account_id}/vehicle/${vehicle_id}`, params)
    .then(({ data }) => data);
}
